import { useParams } from "react-router-dom";
import { projects } from "../projects/index";
import { Project } from "../components/Project";

export function WorkPage() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === id);

  if (!project) return <p>Not found</p>;

  return <Project {...project} />;
}
